import { IOnlineUserData } from '@gem/models/userModel';

import Entities from 'STORE';

function handleUpdate(statuses: IOnlineUserData[] = [], clear = false): void {
  if (clear) {
    Entities.usersStore.resetOnlineStatuses();
  }

  const filteredStatuses = statuses.filter((status) => {
    const currentOnlineStatus = Entities.usersStore.getOnlineStatusByUserId(status.userId);

    if (!currentOnlineStatus) {
      return true;
    }

    return status.lastOnlineTs > currentOnlineStatus.lastOnlineTs;
  });

  const mappedStatuses = filteredStatuses.map((status) => [status.userId, status]);

  Entities.usersStore.mergeOnlineStatuses(mappedStatuses);
}

export async function handleBatchedOnlineStatuses(statuses: IOnlineUserData[]): Promise<void> {
  handleUpdate(statuses, true);
}

export async function handleChangeOnlineStatus(status: IOnlineUserData): Promise<void> {
  handleUpdate([status]);
}
